<template>
	<div class="mdynamicCo">
		<div class="menuBox">
			<div class="menuImgBox" @click="open">
				<img class="menuImg" src="../../assets/mImg/menuIcon.png" alt="">
			</div>
			<div class="lansuImgBox">
				<img class="lansuImg" src="../../assets/logo2.png" alt="">
			</div>
			<!-- <div class="blackBox"></div> -->
		</div>
		<div class="firstBoxMdy">
			<img class="mFirst" src="../../assets/mImg/mjijinshouNew.jpg">
		</div>

		<el-drawer class="drawerBox" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
			unique-opened>
			<el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" @open="handleOpen"
				@close="handleCloseMenu" router>
				<el-menu-item index="/m">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</el-menu-item>
				<el-menu-item index="/maboutLansu">
					<i class="el-icon-document"></i>
					<span slot="title">关于我们</span>
				</el-menu-item>
				<el-menu-item index="/mbrandLansu">
					<i class="el-icon-data-analysis"></i>
					<span slot="title">美业菩提</span>
				</el-menu-item>
				<el-menu-item index="/mDynamicLanshu">
					<i class="el-icon-star-off"></i>
					<span slot="title">菩提基金会</span>
				</el-menu-item>
				<el-submenu index="5">
					<template slot="title">
						<i class="el-icon-trophy"></i>
						<span>兰树品牌</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mhuaibrand">淮树</el-menu-item>
						<el-menu-item index="/mxinbrand">心清堂</el-menu-item>
						<el-menu-item index="/mshuibrand">水姻缘</el-menu-item>
						<el-menu-item index="/myibrand">一清堂</el-menu-item>
						<!-- <el-menu-item index="/mzhongbrand"><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></el-menu-item> -->
						<el-menu-item index="/mlanshuBrand">兰树</el-menu-item>
						<el-menu-item index="/mzbqfBrand">植本清方</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item index="/mTrends">
					<i class="el-icon-bell"></i>
					<span slot="title">兰树动态</span>
				</el-menu-item>
			</el-menu>

		</el-drawer>

		<div class="dynamicBody">
			<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
				<el-tab-pane label="基金会介绍" name="first">
					<div class="dyBodyMiddle">
						<div class="firstBox">
							<div class="firstBoxTop firstBoxTop2">菩提基金会由来</div>
							<div class="firstBoxTitleBox">
								据中国出生缺陷监测网的数据统计，手足畸形的发病率近有千分之一。在常见的手足畸形中，又以拇指为多。而由于手部功能的精细性，手部畸形的矫正具有“难度大、费用高、需多次手术”的特点，而这是许多贫困家庭难以承受的，也导致很多患病儿童没有得到及时有效的治疗。
							</div>
							<div class="firstBoxTitleBox2">
								为了帮助他们得到更好的救助和治疗，兰树企业特此成立了杭州兰树菩提慈善基金会。
							</div>
						</div>

						<div class="firstBox">
							<div class="firstBoxTop firstBoxTop2">菩提基金会简介</div>
							<div class="firstBoxTitleBox">
								杭州兰树菩提慈善基金会是由兰树化妆品股份有限公司发起，在浙江省民政局注册成立的非公募基金会。基金会成立于2019年7月，注册资金200万元。
							</div>
							<div class="firstBoxTitleBox2">
								自成立以来，基金会秉承“爱是正大无私的奉献”的精神，聚焦教育支持、扶贫济困、儿童发展和灾害救助等领域，以“高效、专业，创新”的工作理念，“诚信、透明”的工作态度，接受政府及公众的监督。
							</div>
							<div class="firstBoxTitleBox3">
								菩提基金会积极探索可持续发展的公益模式，注重经济效益与社会效益的平衡发展，努力实现企业与社会的共赢局面。
							</div>
						</div>

						<div class="firstBox">
							<div class="firstBoxTop2">菩提基金会宗旨</div>
							<div class="zongzhiImgBox">
								<img class="zongzhiImg" src="../../assets/mImg/dyInfo01.jpg" alt="">
							</div>
							<div class="firstBoxTitleBox">立足公益、面向社会，关注医疗、教育、民生等问题，关心困难群体，聚集多方公益慈善力量，积极开展助医、助学、助困项目。
							</div>

						</div>

						<div class="firstBox">
							<div class="firstBoxTop2">菩提基金会愿景</div>
							<div class="zongzhiImgBox">
								<img class="zongzhiImg" src="../../assets/mImg/dyInfo02.jpg" alt="">
							</div>
							<div class="firstBoxTitleBox">通过公益反哺社会，让公益成为一项可持续发展事业。</div>
						</div>

						<div class="firstBox">
							<div class="firstBoxTop2">菩提基金会使命</div>
							<div class="zongzhiImgBox">
								<img class="zongzhiImg" src="../../assets/mImg/dyInfo03.jpg" alt="">
							</div>
							<div class="firstBoxTitleBox">助学扶贫 助医扶弱 成就他人 善行天下</div>
						</div>
					</div>
				</el-tab-pane>

				<el-tab-pane label="基金会新闻" name="second">
					<div class="dyNewMainBox">
						<div class="dyNewMainBoxMiddle" v-for="(item,index) in newsItems" :key="index"
							@click="enterDyDeatil(item.id)">
							<div class="dyNewMainBoxItem">
								<div class="dyNewMainBoxItemImg">
									<img class="dyNewImg" :src="item.thumbnail_url" alt="">
								</div>
								<!-- <div class="dyNewsContent">
									<div class="dyNewsContentTitle busiz-text-ellipes1">{{item.title}}</div>
								</div>
								 -->
								<!-- <div class="dyNewsContentTitle busiz-text-ellipes1">
									 {{item.title}}
								 </div> -->
								<div class="dyNewsContentTitle busiz-text-ellipes1">
									{{item.title}}
								</div>
							</div>
							<div class="dyline"></div>
						</div>
					</div>
				</el-tab-pane>

				<el-tab-pane label="基金会项目" name="third">
					<div class="projectBox">

						<div class="projectTitle">扶贫救灾-齐心抗疫 公益捐款50万</div>
						<div class="projectText">
							“一方有难，八方支援”，面对来势汹汹的新型冠状病毒感染的肺炎疫情，兰树企业高度重视，积极响应，以高度的社会责任感和强烈的家国情怀迅速加入到战“疫”行动中来，并在第一时间向湖北省红十字会捐款50万。
						</div>
						<div class="projectImgBox">
							<img class="projectImg" src="../../assets/mImg/projectI1.png" alt="">
						</div>
						<div class="projectText">
							“疫情当前，我们每个人都义不容辞，企业更该走在前面。”兰树企业董事长钟鸣先生对员工这样说道。同时钟鸣先生不忘企业初心和使命，勇担兰树企业抗击疫情总指挥，领导企业全体员工齐心共力，共克时艰。
						</div>

						<div class="projectTitle">儿童发展-大拇指工程 3年捐助600万</div>
						<div class="projectText">善行天下·大拇指工程”大型公益慈善项目已走进新疆乌鲁木齐、云南红河以及革命圣地陕西延安等地，使近百名贫困先天性手足畸形患者得到免费治疗。
						</div>
						<div class="projectImgBox projectImgBox2">
							<img class="projectImg" src="../../assets/mImg/projectI2.png" alt="">
						</div>
						<div class="projectText">
							多年来在钟鸣先生的带领下，兰树企业一直积极投身于慈善事业，2019年与温州慈善总会共同成立《大拇指慈善基金》，3年援助600万元，用于治疗全国患有手部先天畸形的患儿，同时向浙江省民政厅申请成立了《兰树菩提慈善基金会》。兰树企业将不遗余力在公益事业中贡献力量，立足公益、面向社会、关注医疗、关注教育等民生事业，聚集各方力量积极开展助医、助学等项目，让公益成为企业反哺社会的一项可持续发展的事业。
						</div>
						<div class="projectText">厉兵秣马，砥砺前行，兰树企业已经做好了各项准备，将以更饱满的热情、更结实的脚步、更专业的服务迎接2021年的挑战，续写兰树企业新篇章。
						</div>
					</div>
				</el-tab-pane>

				<el-tab-pane label="联系我们" name="fifth">
					<div class="baiduMapBox">
						<baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler">
							<bm-info-window :position="center" title="浙江省杭州市上城区越秀维多利中心A座17楼" :show="show"
								@close="infoWindowClose" @open="infoWindowOpen">
								<p v-text="contents" class="styleContent"></p>
							</bm-info-window>
						</baidu-map>
					</div>
					<div class="dyJoinUsMain">
						<div class="dyJoinUsMainBox">
							<div class="joinBoxLeftTitle2 titleStyle1">联系电话</div>
							<div class="joinBoxLeftTitle3 titleStyle2">0571-89025888</div>
							<div class="joinBoxLeftTitle4 titleStyle1">联系邮箱</div>
							<div class="joinBoxLeftTitle5 titleStyle2">postermaster@lasur.com</div>
							<div class="joinBoxLeftTitle6 titleStyle1">联系地址</div>
							<div class="joinBoxLeftTitle7 titleStyle2">浙江省杭州市上城区越秀维多利中心 A座 17楼</div>
						</div>

						<div class="dyJoinUsMainInput">
							<el-input class="nameInput" placeholder="请输入您的姓名" prefix-icon="el-icon-s-custom"
								v-model="name">
							</el-input>

							<el-input class="phoneInput" placeholder="请输入您的电话" prefix-icon="el-icon-phone"
								v-model="telephone">
							</el-input>

							<el-input class="companyInput" placeholder="请输入您公司名称" prefix-icon="el-icon-office-building"
								v-model="corporate_name">
							</el-input>

							<el-input class="needsInput" type="textarea" :rows="8" placeholder="请输入您的需求"
								v-model="demand">
							</el-input>
						</div>

						<div class="submitBtnBox">
							<el-button class="submitBtn" type="primary" @click="submit()" round>马上提交</el-button>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>

		<div class="footerBoxMain">
			<div class="footerBoxMainMiddle">
				<div class="footerBoxTitle">快捷导航</div>
				<div class="bottomNavFirst bottomNav1">
					<div class="mHomeName">
						<router-link to="/m" tag="a">首页</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mDynamicLanshu" tag="a">菩提基金会</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav2">
					<div class="mHomeName">
						<router-link to="/maboutLansu" tag="a">关于兰树</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mhuaibrand" tag="a">兰树品牌</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav3">
					<div class="mHomeName">
						<router-link to="/mbrandLansu" tag="a">美业菩提</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mTrends" tag="a">兰树动态</router-link>
					</div>
				</div>
				<div class="footerBoxTitle footerBoxTitle2">联系我们</div>
				<div class="contactFirst contactFirst1">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/emailIcon.png" alt="">
					</div>
					<div class="contactContent">
						邮箱：postermaster@lasur.com
					</div>
				</div>
				<div class="contactFirst contactFirst2">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/phoneIcon.png" alt="">
					</div>
					<div class="contactContent">
						电话：0571-89025888
					</div>
				</div>
				<div class="contactFirst contactFirst3">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/gpsIcon.png" alt="">
					</div>
					<div class="contactContent">
						浙江省杭州市之江东路越秀·维多利中心A座 17楼
					</div>
				</div>
			</div>
			<div class="bottomLine"></div>
			<div class="codeBoxMain">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { myGet, myPost, login } from "../../api/http.js";
import { nav_js } from "../../navigation/js/bootsnav.js";
export default {
	data() {
		return {
			center: { lng: 0, lat: 0 },
			zoom: 3,
			show: true,
			contents: '0571-89025888',
			name: '',
			telephone: '',
			corporate_name: '',
			demand: '',
			drawer: false,
			direction: 'ltr',
			activeName: 'first',
			newsItems: []
		}
	},
	created() {
		nav_js();
		this.gitSecurity()
	},
	methods: {
		handleClose(done) {
			done()
		},
		open() {
			this.drawer = true
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleCloseMenu(key, keyPath) {
			console.log(key, keyPath);
		},
		handleClick(tab, event) {
			console.log(tab, event);
		},
		gitSecurity() {
			myPost("api/charitynewslist/", {
				pageNum: this.pageNum,
				pageSize: 6
			}).then((res) => {
				console.log("res", res)
				this.newsItems = res.data.videolist;
				this.total = res.data.total_num;
			});
		},
		enterDyDeatil(opaction) {
			this.$router.push({ path: '/mDyNewsDetail', query: { userId: opaction } });
		},
		handler({ BMap, map }) {
			console.log(BMap, map)
			this.center.lng = 120.239058;
			this.center.lat = 30.273104;
			this.zoom = 15
		},
		infoWindowClose(e) {
			this.show = false
		},
		clear() {
			this.contents = ''
		},
		infoWindowOpen(e) {
			this.show = true
		},
		//提交表单
		submit() {
			myPost("api/demand/", {
				name: this.name,
				telephone: this.telephone,
				corporate_name: this.corporate_name,
				demand: this.demand,
			}).then((res) => {
				if (res.data.code == 200) {
					this.$message.success('提交成功！')
					this.name = '',
						this.telephone = '',
						this.corporate_name = '',
						this.demand = ''
				} else {
					this.$message.error('提交失败！')
				}
			})
		},
	}
}
</script>

<style scoped>
.mdynamicCo {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}


.mFirst {
	width: 100%;
}

.mFirstBox {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 99;
}


.mFirstBoxImgBox {
	width: 100%;
	margin-top: 0.5rem;
}

.mFirstBoxImg {
	width: 50%;
	float: left;
	position: relative;
	left: 0.5rem;
}

.firstBoxMdy {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 3.5rem;
}

.dynamicBody {
	display: flex;
	flex-direction: column;
	width: 100%;
	margin-top: 1rem;
	/* position:absolute;
		 top:30em; */
}

.dyBodyMiddle {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}


.firstBox {
	display: flex;
	flex-direction: column;
	width: 90%;
	margin: 0 auto;
}

.firstBoxTop {
	text-align: left;
	padding-left: 0.5em;
	border-left: 4px #0F3F93 solid;
	font-size: 1.2rem;
	font-family: MicrosoftYaHei;
	color: #111111;
	line-height: 18px;
}

.firstBoxTop2 {
	text-align: left;
	padding-left: 0.5em;
	border-left: 4px #0F3F93 solid;
	font-size: 1.2rem;
	font-family: MicrosoftYaHei;
	color: #111111;
	line-height: 18px;
	margin-top: 2rem;
}

.firstBoxTitleBox {
	width: 90%;
	margin: 0 auto;
	color: #333333;
	font-size: 1rem;
	line-height: 1.5625rem;
	margin-top: 1rem;
}

.firstBoxTitleBox2 {
	width: 90%;
	margin: 0 auto;
	color: #333333;
	font-size: 1rem;
	line-height: 1.5625rem;
	margin-top: 0.5rem;
}

.firstBoxTitleBox3 {
	width: 90%;
	margin: 0 auto;
	color: #333333;
	font-size: 1rem;
	line-height: 1.5625rem;
	margin-top: 0.5rem;
}

.zongzhiImgBox {
	width: 90%;
	margin: 0 auto;
	margin-top: 1rem;
}

.zongzhiImg {
	width: 100%;
}


.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #333333;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	font-weight: 400;
	color: #222222;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}


.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;

	font-weight: 400;
	color: #222222;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;

	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #000000;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}


.dyNewMainBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 1rem;
}

.dyNewMainBoxMiddle {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.dyNewMainBoxItem {
	width: 95%;
	display: flex;
	flex-direction: row;
	margin-top: 1rem;
	margin: 0 auto;
}



.dyNewMainBoxItemImg {
	width: 40%;
	border-radius: 0.5rem;
}



.dyNewImg {
	width: 100%;
	border-radius: 0.5rem;
}

.dyNewsContent {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-left: 1rem;
}


.dyNewsContentTitle {
	width: 60%;
	color: #000000;
	font-size: 1rem;
	padding-left: 1rem;
}


.dyNewsContentTime {
	color: #999999;
	font-size: 0.875rem;
}



.busiz-text-ellipes1 {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	/*! autoprefixer: off */
	-webkit-box-orient: vertical;
	/*autoprefixer: on */
}

.dyline {
	width: 100%;
	height: 0.4rem;
	background-color: #F3F3F3;
	opacity: 0.3;
	margin-top: 0.5rem;
}

.baiduMapBox {
	width: 100%;
}

.bm-view {
	width: 100%;
	height: 280px;
}


.dyJoinUsMain {
	width: 100%;
	display: flex;
	flex-direction: column;
	padding-bottom: 2rem;
}


.dyJoinUsMainBox {
	width: 80%;
	display: flex;
	flex-direction: column;
	margin: 0 auto;
}


.titleStyle1 {
	font-size: 1.1rem;
	font-weight: 400;
	color: #666666;
	line-height: 17px;
	margin-top: 2em;
}

.titleStyle2 {
	font-size: 1rem;
	font-weight: 400;
	color: #212121;
	line-height: 25px;
}

.dyJoinUsMainInput {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 1rem;
}

.joinUsBoxMainNew {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.nameInput {
	width: 80%;
	outline: none;
	margin-top: 1rem;
}

.companyInput {
	width: 80%;
	outline: none;
	margin-top: 1rem;
}

.phoneInput {
	width: 80%;
	outline: none;
	margin-top: 1rem;
}

.needsInput {
	width: 80%;
	outline: none;
	margin-top: 1rem;
}

.submitBtn {
	width: 8em;
}

.submitBtnBox {
	width: 80%;
	margin: 0 auto;
	display: flex;
}

.projectBox {
	width: 90%;
	display: flex;
	flex-direction: column;
	margin: 0 auto;
}

.projectImgBox {
	width: 100%;
	margin-top: 1rem;
}


.projectImg {
	width: 100%;
}

.projectTitle {
	margin-top: 1rem;
	color: #222222;
	font-weight: 500;
	font-size: 1.2rem;
}

.projectText {
	color: #666666;
	font-size: 1rem;
	margin-top: 1rem;
	line-height: 25px;
}


.footerBoxMainMiddle {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.footerBoxTitle {
	color: #FFFFFF;
	font-size: 1rem;
	font-weight: 500;
}

.bottomNavFirst {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.mHomeName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.ptjjhName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.contactFirst {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.contactImgBox {
	width: 0.8rem;
}

.contactImg {
	width: 100%;
}

.contactContent {
	color: #FFFFFF;
	font-size: 0.7rem;
	opacity: 0.7;
	margin-left: 0.5rem;
}

.bottomLine {
	width: 100%;
	height: 2px;
	background: #FFFFFF;
	opacity: 0.1;
	margin-top: 1.5rem;
}

.footerBoxTitle2 {
	margin-top: 1.5rem;
}

.contactFirst1 {
	margin-top: 1rem;
}

.codeBoxMain {
	width: 50%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-top: 1.5rem;
}


.codeImg {
	width: 80%;
}

.codeText {
	font-size: 0.5em;
	color: #FFFFFF;
	line-height: 20px;
	opacity: 0.7;
	/* margin-top: 0em; */
}

.footerBoxMain {
	width: 100%;
	background-color:  #2c5eff;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
	padding-bottom: 1rem;
}

.footerLeft {
	text-align: center;
	font-size: 0.9em;
	color: #FFFFFF;
	line-height: 24px;
	opacity: 0.7;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
	opacity: 0.7;
}

.contactFirst2 {
	margin-top: 0.5rem;
}

.contactFirst3 {
	margin-top: 0.5rem;
}

/* 新导航栏 */
.menuBox {
	position: fixed;
	width: 100%;
	display: flex;
	top: 0;
	flex-direction: row;
	background: #FFFFFF;
	padding-top: 0.8rem;
	padding-bottom: 0.5rem;
	align-items: center;
	justify-content: space-between;
	z-index: 999;
}

.menuImgBox {
	width: 33.33%;
}

.menuImg {
	width: 17%;
	margin-left: 1rem;
}

.lansuImgBox {
	width: 40%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-right: 1rem;
}

.blackBox {
	width: 33.33%;

}

.lansuImg {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mComponents/mdynamicLanshu.vue